import React from "react";
export const Footer = () => {
  return (
    <>
      <div className="footer-main-bottom championsTrophyFooter">
        <footer className="footer-section">
          <div className="footer-content">
            <div className="container">
              <div className="row align-items-center">
                <div className="col-sm-12 col-md-12 col-lg-6 ">
                  <div className="content">
                    <div className="text">
                      <p>
                        ©2026 VZY. All Rights Reserved. www.vzy.one or
                        abbreviated VZY is an online video streaming service
                        where visitors can access a variety of films, web
                        series, Live TV serials, user generated content, etc.,
                        for which viewing rights are given by content copyright
                        holders. VZY and all related channel and programming
                        logos are service marks of, and all related programming
                        audio-visuals and elements are the property of Dish
                        Infra Services Private Limited.
                      </p>
                    </div>
                  </div>
                </div>
                <div className="col-sm-12 col-md-12 col-lg-6 ">
                  <div className="platfom-footer-logos">
                    <ul>
                      <li>TV Platforms</li>
                      <li>
                        <div className="image">
                          <a
                            target="_blank"
                            rel="noreferrer"
                            href="https://ind01.safelinks.protection.outlook.com/?url=https%3A%2F%2Fplay.google.com%2Fstore%2Fapps%2Fdetails%3Fid%3Dcom.watcho_multi&data=05%7C02%7Csunilkumar.singh.it%40d2hdesk.com%7C3b474342a5c441fe441708dce1e35f86%7C2b974f695cb84d58ae71c7d3f88e454e%7C0%7C0%7C638633613921629696%7CUnknown%7CTWFpbGZsb3d8eyJWIjoiMC4wLjAwMDAiLCJQIjoiV2luMzIiLCJBTiI6Ik1haWwiLCJXVCI6Mn0%3D%7C0%7C%7C%7C&sdata=HWc2lqNoCI%2Bcc8Z%2B%2BPiJPZv4geUGUgdl4afUWrzIYyM%3D&reserved=0"
                          >
                            <img src="Images/DKDOffer/f-logo1.svg" alt="" />
                          </a>
                        </div>
                        <div className="image">
                          <a
                            target="_blank"
                            rel="noreferrer"
                            href="https://ind01.safelinks.protection.outlook.com/?url=https%3A%2F%2Fwww.amazon.in%2FWatcho-Original-Spotlight-Exclusive-Shows%2Fdp%2FB07XPG5FW5&data=05%7C02%7Csunilkumar.singh.it%40d2hdesk.com%7Ca2f0a735c90c41f989a008dce75865ed%7C2b974f695cb84d58ae71c7d3f88e454e%7C0%7C0%7C638639614099960778%7CUnknown%7CTWFpbGZsb3d8eyJWIjoiMC4wLjAwMDAiLCJQIjoiV2luMzIiLCJBTiI6Ik1haWwiLCJXVCI6Mn0%3D%7C0%7C%7C%7C&sdata=qUFxHyACDUi0X8bR2kyd93%2Bp29MYaSwFAFIoncjq1to%3D&reserved=0"
                          >
                            <img src="Images/DKDOffer/f-logo2.svg" alt="" />
                          </a>
                        </div>
                        <div className="image">
                          <a
                            target="_blank"
                            rel="noreferrer"
                            href="https://ind01.safelinks.protection.outlook.com/?url=https%3A%2F%2Fapps.apple.com%2Fin%2Fapp%2Fwatcho-new-web-series-livetv%2Fid1440733653%3Fplatform%3DappleTV&data=05%7C02%7Csunilkumar.singh.it%40d2hdesk.com%7C3b474342a5c441fe441708dce1e35f86%7C2b974f695cb84d58ae71c7d3f88e454e%7C0%7C0%7C638633613921647310%7CUnknown%7CTWFpbGZsb3d8eyJWIjoiMC4wLjAwMDAiLCJQIjoiV2luMzIiLCJBTiI6Ik1haWwiLCJXVCI6Mn0%3D%7C0%7C%7C%7C&sdata=k9hbgGbarb8nkl9cpto5zL6tFyKH3OwNhpMXAh60rI4%3D&reserved=0"
                          >
                            <img src="Images/DKDOffer/f-logo3.svg" alt="" />
                          </a>
                        </div>
                        <div className="image">
                          <a
                            target="_blank"
                            rel="noreferrer"
                            href="https://www.samsung.com/levant/tvs/smart-tv/smart-hub-and-apps/"
                          >
                            <img src="Images/DKDOffer/f-logo4.svg" alt="" />
                          </a>
                        </div>
                        <div className="image">
                          <a
                            target="_blank"
                            rel="noreferrer"
                            href="https://in.lgappstv.com/main/tvapp/detail?appId=1227441"
                          >
                            <img src="Images/DKDOffer/f-logo5.svg" alt="" />
                          </a>
                        </div>
                      </li>
                    </ul>
                    <ul>
                      <li>Mobile Platforms</li>
                      <li>
                        <div className="image">
                          <a
                            target="_blank"
                            rel="noreferrer"
                            href="https://apps.apple.com/in/app/vzy-29-otts-in-1-app/id6761709351"
                          >
                            <img src="Images/DKDOffer/f-logo6.svg" alt="" />
                          </a>
                        </div>
                        <div className="image">
                          <a
                            target="_blank"
                            rel="noreferrer"
                            href="https://play.google.com/store/apps/details?id=com.vzy.one&hl=en_IN"
                          >
                            <img src="Images/DKDOffer/f-logo7.svg" alt="" />
                          </a>
                        </div>
                      </li>
                    </ul>
                    <ul>
                      <li>Set-Top- Box</li>
                      <li>
                        <div className="image">
                          <a
                            target="_blank"
                            rel="noreferrer"
                            href="https://www.dishtv.in/"
                          >
                            <img src="Images/dishTV-logo_New.png" alt="" />
                          </a>
                        </div>
                        <div className="image">
                          <a
                            target="_blank"
                            rel="noreferrer"
                            href="https://www.d2h.com/"
                          >
                            <img src="Images/DKDOffer/f-logo9.svg" alt="" />
                          </a>
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="social-menu">
            <div className="container">
              <div className="social-menu">
                <div className="card-n">
                  <ul className="data-nev">
                    <li className="a-nev-links" id="projects">
                      <a
                        href="https://www.vzy.one/en/supportPage/privacyPolicy"
                        target="_blank"
                        rel="noreferrer"
                      >
                        Privacy Policy
                      </a>
                    </li>
                    <li
                      className="a-nev-links copenModal"
                      dataid="data1"
                      id="termsConditions"
                    >
                      <a
                        href="https://www.vzy.one/en/supportPage/termsOfUse"
                        target="_blank"
                        rel="noreferrer"
                      >
                        Terms & Conditions
                      </a>
                    </li>
                    <li className="a-nev-links" id="swagTerms">
                      <a
                        href="https://www.vzy.one/en/supportPage/termsOfUse"
                        target="_blank"
                        rel="noreferrer"
                      >
                        Swag Terms
                      </a>
                    </li>
                    <li className="a-nev-links" id="grievance">
                      <a
                        href="https://www.vzy.one/en/supportPage/grievance"
                        target="_blank"
                        rel="noreferrer"
                      >
                        Grievance
                      </a>
                    </li>
                    <li className="a-nev-links" id="cookies">
                      <a
                        href="https://www.vzy.one/en/supportPage/cookiePolicy"
                        target="_blank"
                        rel="noreferrer"
                      >
                        Cookies
                      </a>
                    </li>
                    <li className="a-nev-links" id="aboutus">
                      <a
                        href="https://www.vzy.one/en/supportPage/aboutus"
                        target="_blank"
                        rel="noreferrer"
                      >
                        About Us
                      </a>
                    </li>
                    <li className="a-nev-links" id="faqs">
                      <a
                        href="https://www.vzy.one/en/account"
                        target="_blank"
                        rel="noreferrer"
                      >
                        FAQ's
                      </a>
                    </li>
                  </ul>
                </div>
                <div className="social-links">
                  <ul>
                    <li>Connect with us :</li>
                    <li>
                      <a
                        target="_blank"
                        rel="noreferrer"
                        href="https://www.facebook.com/share/1CLV8fPZBZ/?mibextid=wwXIfr"
                        className=""
                      >
                        {" "}
                        <i className="fab fa-facebook" aria-hidden="true"></i>
                      </a>
                    </li>
                    <li>
                      <a
                        target="_blank"
                        rel="noreferrer"
                        href="https://www.instagram.com/vzystream"
                        className=""
                      >
                        <i className="bi bi-instagram"></i>
                      </a>
                    </li>
                    <li>
                      <a
                        target="_blank"
                        rel="noreferrer"
                        href="https://x.com/vzyindia?s=11"
                        className=""
                      >
                        <i className="bi bi-twitter"></i>
                      </a>
                    </li>
                    <li>
                      <a
                        target="_blank"
                        rel="noreferrer"
                        href="https://www.youtube.com/@VzyStream"
                        className=""
                      >
                        <i className="bi bi-youtube"></i>
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </footer>
      </div>
    </>
  );
};
